import { ADD_COMBO_SERVICE_TO_CART, UPDATE_COMBO_SERVICE_CART } from './type';

// CART
export const addComboServiceToCartStore = (payload) => {
    return {
        type: ADD_COMBO_SERVICE_TO_CART,
        payload,
    };
};

export const updateComboServiceCartStore = (payload) => ({
    type: UPDATE_COMBO_SERVICE_CART,
    payload,
});
